import React from "react";
import { K } from "../theme";

export const Bg = ({ children, c = K.p, dot, sm }) =>
  <span
    className={`inline-flex items-center gap-1.5 rounded-pill font-semibold whitespace-nowrap border ${sm ? "px-[9px] py-[3px] text-[11px]" : "px-[11px] py-[4px] text-[13px]"}`}
    style={{ background: `${c}0d`, color: c, borderColor: `${c}33` }}
  >
    {dot && <span className="w-[6px] h-[6px] rounded-full flex-shrink-0" style={{ background: c }} />}
    {children}
  </span>;
